// extracted by mini-css-extract-plugin
export default {"groupInfo":"style_groupInfo__PG6e1","infoItem":"style_infoItem__AGiy7","label":"style_label__HpEfX","value":"style_value__UcDmC"};